function animateHeroBackground (){
    var lFollowX = 0,
        lFollowY = 0,
        x = 0,
        y = 0,
        friction = 1 / 40;

    function moveBackground() {
        x += (lFollowX - x) * friction;
        y += (lFollowY - y) * friction;

        var translate = 'translate(' + Math.round(x) + 'px, ' + Math.round(y)+ 'px) scale(1.1)';

        $('.background-image-blur').css({
            '-webit-transform': translate,
            '-moz-transform': translate,
            'transform': translate
        });

        window.requestAnimationFrame(moveBackground);
    }

    $('.hero').on('mousemove', function(e) {
        var lMouseX = Math.max(-100, Math.min(100, $('.hero').width() / 2 - e.clientX));
        var lMouseY = Math.max(-100, Math.min(100, $('.hero').height() / 2 - e.clientY));
        lFollowX = -(20 * lMouseX) / 100; //
        lFollowY = -(40 * lMouseY) / 100;
    });

    moveBackground()
}